<template lang="pug">
    .login(v-if="isUserLoggedIn !== null")
        div(v-if="error !== ''")
            h3.danger {{error}}
        form(v-if="!isUserLoggedIn")
            div
                label(for="email") Email
                input(name="email",type="text",placeholder="email",v-model="email")
            div
                label(for="password") Password
                input(name="password",type="password",v-model="password")
            div
                input(type="button" value="login" v-on:click="login")
        div(v-if="isUserLoggedIn")
            input(type="button" value="logout" v-on:click="logout")

</template>

<script>
// @ is an alias to /src
import firebase from '@/services/firebaseConfig';
import 'firebase/auth';
import authService from '@/services/authService';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      isUserLoggedIn: null,
    };
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.$router.replace('/');
        })
        .catch((error) => {
          this.error = error;
        });
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace('/');
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
  beforeCreate(){
    authService.$on('authChange', (user) => {
      this.isUserLoggedIn = !!user;
    })
    this.isUserLoggedIn = !!user.isUserLoggedIn;
  }
};
</script>
